import type { components } from "./generated/schema";
import { apiRequest, csrfToken } from "./request";

export type SessionPayload = components["schemas"]["Session"];
export type SessionWorkspace = components["schemas"]["Workspace"];
export { ApiRequestError } from "./request";

async function loadSession() {
  return (await apiRequest<SessionPayload>("/api/v1/auth/session/")).data;
}

export const authApi = {
  session: loadSession,
  login: async (email: string, password: string) => {
    if (!csrfToken()) await loadSession();
    return (
      await apiRequest<SessionPayload>("/api/v1/auth/login/", {
        method: "POST",
        body: JSON.stringify({ email, password }),
      })
    ).data;
  },
  logout: async () => {
    await apiRequest<void>("/api/v1/auth/logout/", { method: "POST" });
  },
  changePassword: async (currentPassword: string, newPassword: string) => {
    await apiRequest<void>("/api/v1/auth/change-password/", {
      method: "POST",
      body: JSON.stringify({
        current_password: currentPassword,
        new_password: newPassword,
      }),
    });
  },
};
